import { render, staticRenderFns } from "./PageApp.vue?vue&type=template&id=bd1ae286"
import script from "./PageApp.vue?vue&type=script&lang=js"
export * from "./PageApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports